import styled from 'styled-components';

const TableRow = styled.tr`
  display: contents;
`;

TableRow.displayName = 'StyledTableRow';

export default TableRow;
